import { toLower } from "lodash"

export const isIndexAsset = (assetType) => toLower(assetType) === "index"

// One decider for the assetDetails endpoint's shape: `data.url()` builds the request from it and the
// identity gate matches on it, so a new asset type cannot reach one and miss the other. The `?date=`
// the security endpoint also takes stays out — it narrows the payload, it is not part of the identity.
export const getAssetDetailsDir = (assetType) => (
  isIndexAsset(assetType) ? "indices" : `security/${toLower(assetType)}`
)

export const computeAssetTickerMic = (asset) => {
  if (!asset) { return null }

  const { ticker, exchange } = asset
  return ticker && exchange ? { ticker, mic: exchange } : null
}
